import React, { useCallback, useEffect, useState } from "react";
import { Check, Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { PhotoThumb } from "./Photos";

const MOOD = { happy: "😃", ok: "😐", sad: "😢" };

export const HomeInbox = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const load = useCallback(() => api.get("/teacher/diary/inbox").then((r) => setItems(r.data.items)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const seen = async (x) => { await api.post("/teacher/diary/inbox/seen", { student_id: x.student_id, date: x.date }); load(); };
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50" data-testid="home-inbox">
      <button type="button" onClick={() => setOpen((v) => !v)} className="flex w-full items-center justify-between px-3 py-2 text-sm font-bold text-sky-900" data-testid="home-inbox-toggle">
        <span className="flex items-center gap-2"><Inbox className="h-4 w-4" /> New from home</span>
        <span className={`rounded-full px-2 py-0.5 text-xs ${items.length ? "bg-red-600 text-white" : "bg-white text-slate-500"}`} data-testid="home-inbox-count">{items.length}</span>
      </button>
      {open && <div className="space-y-2 px-3 pb-3">
        {items.length === 0 && <p className="text-xs text-slate-500">Nothing new from home.</p>}
        {items.map((x, i) => (
          <div key={`${x.student_id}-${x.date}`} className="rounded-lg bg-white p-2 text-sm" data-testid={`inbox-item-${x.student_id}-${x.date}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <p className="font-semibold text-slate-900">{x.name} <span className="text-xs font-normal text-slate-500">{x.student_class} · {x.date}</span> {x.mood && MOOD[x.mood]}</p>
                <p className="text-xs text-slate-700">{x.class_not_done?.length || x.hw_not_done?.length ? "Some work not done" : "Everything done"}{x.note ? ` · extra: “${x.note}”` : ""}</p>
                {x.class_not_done?.length > 0 && <p className="text-xs font-semibold text-red-700">Not done in class: {x.class_not_done.join(" · ")}</p>}
                {x.hw_not_done?.length > 0 && <p className="text-xs font-semibold text-red-700" data-testid={`inbox-hw-not-done-${i}`}>Homework not done: {x.hw_not_done.join(" · ")}</p>}
                {x.help && <p className="text-xs font-semibold text-red-700">Needs help: {x.help}</p>}
              </div>
              <button type="button" onClick={() => seen(x)} className="flex shrink-0 items-center gap-1 rounded-full bg-emerald-600 px-2.5 py-1 text-xs font-bold text-white" data-testid={`inbox-seen-${x.student_id}-${x.date}`}><Check className="h-3.5 w-3.5" /> Seen</button>
            </div>
            {x.photos.length > 0 && <div className="mt-1 flex gap-1.5">{x.photos.map((p) => <PhotoThumb key={p} url={`/teacher/diary/photo/${p}`} testid={`inbox-photo-${p}`} />)}</div>}
          </div>
        ))}
      </div>}
    </div>
  );
};
